import { serviceMaker, methods, api } from "@/http/index.js";

export const getConfigurationsData = () =>
  serviceMaker(`/configurations?tenant=default`, methods.GET, api.NGB);
export const getByIdConfigurations = (payload) =>
  serviceMaker(`/configurations/${payload.id}`, methods.GET, api.NGB);
export const editByIdConfigurations = (payload) =>
  serviceMaker(`/configurations/${payload.id}`, methods.PUT, api.NGB, {
    value: payload.value,
  });
export const updateConfigurationFlag = (id, data) =>
  serviceMaker(`/configurations/${id}`, methods.PUT, api.NGB, data);
export const getPaymentGatewayConfigsData = () =>
  serviceMaker(`/paymentgatewayconfigs`, methods.GET, api.NGB);
export const editByIdPaymentGatwayConfigs = (payload) =>
  serviceMaker(`/paymentgatewayconfigs/${payload.id}`, methods.PUT, api.NGB, {
    value: payload.value,
  });
export const updatePaymentgatewayConfigurationFlag = (id, data) =>
  serviceMaker(`/paymentgatewayconfigs/${id}`, methods.PUT, api.NGB, data);
export const getEventactionMappingData = () =>
  serviceMaker(`/eventactionmapping`, methods.GET, api.NGB);
export const updateHooksFlag = (id) =>
  serviceMaker(`/eventactionmapping/${id}`, methods.DELETE, api.NGB);
export const getEventActionTemplate = () =>
  serviceMaker(`/eventactionmapping/template`, methods.GET, api.NGB);
export const createEventActionmapping = (data) =>
  serviceMaker(`/eventactionmapping`, methods.POST, api.NGB, data);
export const editEventActionmapping = (id) =>
  serviceMaker(`/eventactionmapping/${id}?template=true`, methods.GET, api.NGB);
export const editSubmitEventAction = (id, data) =>
  serviceMaker(`/eventactionmapping/${id}`, methods.PUT, api.NGB, data);
export const getEnumData = () => serviceMaker(`/enum/dropdown`, methods.GET, api.NGB);
export const viewEnumData = (data) =>
  serviceMaker(`/enum/${data}`, methods.GET, api.NGB);
export const deleteEnumById = (data) =>
  serviceMaker(`/enum/${data.name}/${data.id}`, methods.DELETE, api.NGB);
export const createEnum = (data) =>
  serviceMaker(`/enum/create`, methods.POST, api.NGB, data);
export const createConfiguration = (data) =>
  serviceMaker(`/configurations/createconfig`, methods.POST, api.NGB, data);